import React from 'react';
import PropTypes from 'prop-types';
import {isUndefined} from 'utils/typeUtils';
import TenantView, {
    TenantDxGrid,
    TenantMobileGrid,
    TenantDxGridContainer,
    TenantFormDialog,
    TenantForm
} from '../TenantView';

const getDxGrid = (DxGrid) => (
    <TenantDxGridContainer component={DxGrid || <TenantDxGrid/>}/>
);

const getMobileGrid = (MobileGrid) => (
    <TenantDxGridContainer component={MobileGrid || <TenantMobileGrid/>}/>
);

const getFormDialog = (Form) => (
    <TenantFormDialog form={Form || <TenantForm/>}/>
);

const getDataTableView = ({breakpoint, tenantDxGrid, tenantMobileGrid}) => {
    if (breakpoint.down('md')) {
        return getMobileGrid(tenantMobileGrid);
    }
    if (isUndefined(tenantDxGrid) || tenantDxGrid) {
        return getDxGrid(tenantDxGrid);
    }
};

export const getTenantView = (props) => {
    const {
        breakpoint,
        tenantDxGrid,
        tenantMobileGrid,
        tenantForm,
        tenantFormDialog,
        tenantView,
        viewName,
        viewStyles,
        params,
    } = props;

    if (tenantView) return tenantView;

    return (
        <TenantView
            key={viewName}
            viewName={viewName}
            dataTable={getDataTableView({
                breakpoint,
                tenantDxGrid,
                tenantMobileGrid
            })}
            formDialog={tenantFormDialog || getFormDialog(tenantForm)}
            viewStyles={viewStyles}
            params={params}
        />
    )
};

getTenantView.propTypes = {
    tenantDxGrid: PropTypes.node,
    tenantForm: PropTypes.node,
    tenantFormDialog: PropTypes.node,
    tenantView: PropTypes.node,
    viewName: PropTypes.string,
};
